import React from "react";
import Deberes from "../images/deberes.png";
import { Helmet } from "react-helmet";

import DeberesActividad from "../images/deberesactividad.jpg";
import DeberesActividad2 from "../images/deberesactividad2.png";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import TitleSmall from "../components/TitleSmall";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  actividad: {
    background: "rgba(255, 213, 55, 0.25)",
    border: "6px solid " + theme.palette.secondary.main,
    "& p": {
      marginLeft: "1em",
    },
    marginBottom: "4em",
  },
}));

const Lamina2 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa: Lámina 2: Deberes y rutinas en casa"
        meta={[
          {
            property: "og:title",
            content: "Lámina 2: Deberes y rutinas en casa",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "El tema de los deberes y rutinas en casa es primordial porque es muy importante que todos los miembros de una familia colaboren y ayuden en todas las labores del cuidado del hogar y nos preocupemos por los demás.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="2" color="primary" />
      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root}
          spacing={2}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} xs={12}>
            <Title title="Deberes y rutinas en casa" color="primary" />
            <p>
              ¡La igualdad comienza en casa! Toda la familia (hijas, hijos,
              mamá, papá y demás miembros) tiene que organizarse para llevar a
              cabo los quehaceres y así poder tener una buena convivencia.
            </p>
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <img src={Deberes} alt="deberes" />
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="primary" />
        <p>
          <strong>
            Observa las imágenes. Luego, une con una línea cada imagen con el
            enunciado que corresponda.
          </strong>
        </p>
        <img src={DeberesActividad} alt="Deberes Actividad" />
        <p>
          <strong>Dialoga en casa a partir de las siguientes preguntas:</strong>
        </p>
        <ul>
          <li>
            En tu hogar, ¿las responsabilidades son compartidas? De ser así,
            explica cómo. ¿Qué hace cada miembro de la familia?
          </li>
          <li>¿Qué responsabilidades tienes tú en casa?</li>
          <li>
            ¿Cómo te sientes cuando cumples con tus responsabilidades? ¿Por qué?
          </li>
        </ul>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <TitleSmall title="LAS RUTINAS A VECES CAMBIAN" color="primary" />
        <Grid
          container
          className={classes.root}
          spacing={2}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={12} xs={12}>
            <p>
              En estos días, nuestras rutinas han cambiado un poco debido a las
              medidas que nos obligan a estar en casa para cuidar nuestra salud.
              Pero en casa no siempre todo marcha bien, pues a veces sentimos
              que algo nos molesta. Cada persona reacciona de diferente manera
              porque no todas se sienten igual ante la misma situación.
            </p>
            <p>
              <strong>
                Observa lo que ocurre en las imágenes. Luego, conversa con
                alguien en casa sobre cómo se sienten Mario, Sara y Renzo.
              </strong>
            </p>
          </Grid>
          <Grid item lg={12} xs={12}>
            <Grid
              container
              className={classes.root}
              spacing={2}
              justify="center"
            >
              <Grid item lg={12} xs={12}>
                <img src={DeberesActividad2} alt="Nuevos habitos" />
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} xs={12}>
            <Actividad color="primary" />
            <p>
              <strong>
                Elige a uno de los personajes y escribe un párrafo o graba un
                video con algunas recomendaciones:
              </strong>{" "}
              ¿cómo puede manejar sus emociones ante esta situación?
            </p>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/06/Ciudadanía-Activa-Lámina-2.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          color="primary"
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 2: Deberes y rutinas en casa'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="La familia"
        anteriorEnlace="/lamina-1-1"
        siguiente="La importancia de la escuela"
        siguienteEnlace="/lamina-1-3"
      />
    </>
  );
};

export default Lamina2;
